// extracted by mini-css-extract-plugin
export default {"logoWrapper":"Logo_logoWrapper__Dhunp","logo":"Logo_logo__u4orc","logoLarge":"Logo_logoLarge__-fZX7"};